import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class WithErrorEvents extends Vue {
  @Emit("error-occurred")
  protected publishAsError(errorMessage: string): string {
    return errorMessage;
  }
}
